import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';

export const endSymbolSyntheticProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolSyntheticAction.create.failed,
    SymbolSyntheticAction.update.failed,
    SymbolSyntheticAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      SymbolSyntheticAction.processing.done({}),
    ];
  }),
);
